import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { useMeContext } from '~/modules/me/useMeContext';
import { USER_DAL } from '~/modules/common/enums';

export const RESOURCE_USER_ROLES_QUERY = gql`
  query GetResourceUserRoles(
    $page: Int
    $pagesize: Int
    $filter: GetResourceUsersFilter
  ) {
    resourceUsers2(page: $page, pagesize: $pagesize, filter: $filter) {
      id
      uri
      displayText
      roles {
        projectRole {
          id: uri
          displayText
        }
        isPrimary
      }
    }
  }
`;
export const useResourceUserPrimaryRole = ({ variables, skip }) => {
  const {
    featureFlags: { isPsaRmpEnhancedProjectManagerPersonaEnabled }
  } = useMeContext();

  const effectiveDataAccessLevelUris = isPsaRmpEnhancedProjectManagerPersonaEnabled
    ? [USER_DAL.PROJECT_MANAGER, USER_DAL.RESOURCE_MANAGER]
    : undefined;

  const { loading, error, data } = useQuery(RESOURCE_USER_ROLES_QUERY, {
    variables: {
      ...variables,
      filter: {
        ...variables?.filter,
        effectiveDataAccessLevelUris
      }
    },
    skip,
    fetchPolicy: 'cache-and-network'
  });

  return {
    loading,
    primaryRole: (data?.resourceUsers2[0]?.roles || []).find(r => r.isPrimary)
      ?.projectRole,
    error
  };
};

export default useResourceUserPrimaryRole;
